import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import InvitesIcon from '@/components/svg/group.svg?inline';
import { Invitee } from '@/models/Invitation';
import { getInvitees } from '@/services/Invitation/Api';
import {
  computed, onMounted, PropType, ref
} from 'vue';
import InviteesTable from '@/views/invites/InviteesTable.vue';
import { filterInvitees, InviteeListMode } from '@/views/invites/utils/filterInvitees';


export default /*#__PURE__*/_defineComponent({
  __name: 'Invitees',
  props: {
  mode: {
    type: String as PropType<InviteeListMode>,
    default: 'all'
  }
},
  setup(__props) {

const props = __props;



const allInvitees = ref<Invitee[]>([]);
const invitees = computed<Invitee[]>(() => filterInvitees(allInvitees.value, props.mode));
const headlineKey = computed<string>(() => (props.mode === 'affiliate' ? 'invites.invitees.headlineAffiliate' : 'invites.invitees.headline'));

onMounted(async () => {
  allInvitees.value = (await getInvitees())?.inviteeList ?? [];
});


return { __sfc: true,props, allInvitees, invitees, headlineKey, BCXMarkdown, InvitesIcon, InviteesTable }
}

})